import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router";
import { Meta } from '@angular/platform-browser';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-all-categories',
  templateUrl: './all-categories.component.html',
  styleUrls: ['./all-categories.component.scss']
    })
export class AllCategoriesComponent {
  
  constructor(public ngxSmartModalService: NgxSmartModalService, public http: HttpClient, private meta: Meta, private router: Router) {
    
    this.ping();
    meta.addTag({name: 'description', content: 'Title and Meta tags examples'});
       meta.addTag({name: 'viewport', content: 'width=device-width, initial-scale=1'});
       meta.addTag({name: 'og:image', content: 'content="http://euro-travel-example.com/thumbnail.jpg'});
  }
  siteID = environment.siteID;
    alltags: any = [];
    public ping() {
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
        let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/endpoint/getTags?siteID='+this.siteID,{
        headers:myheader
      })
      .subscribe(
        data => {
           this.alltags = data['tags'];
        },
        error => {
        }
    );
    }
    refresh(): void {
      window.location.reload();
  }
  }